import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, Form, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap'
import properties from '../../../api/properties/hooks'
import { MODAL_TYPES } from '../../../common/constants'
import { hideModal } from '../../../store/modal'
import { formFields } from './formFields'

interface ReturnToOfferModalProps {
    isOpen: boolean
    returnToOfferModal: {
        id: string
    }
}

const ReturnToOffer = (props: ReturnToOfferModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { isOpen, returnToOfferModal } = props
    const { id } = returnToOfferModal

    const { mutate: cloneProperty, isPending } = properties.CloneProperty.useMutation()

    const initialValues = formFields.reduce<Record<string, number>>((acc, field) => {
        acc[field.name] = field.checked
        return acc
    }, {})

    const formik = useFormik({
        enableReinitialize: true,
        initialValues,
        onSubmit: (values) => {
            const data: string[] = []

            Object.keys(values).forEach((key) => {
                if (values[key] === 1) {
                    data.push(key)
                }
            })

            cloneProperty({ id, data }, { onSuccess: () => handleClose() })
        },
    })

    const handleClose = () => {
        dispatch(hideModal({ modalType: MODAL_TYPES.RETURN_TO_OFFER_MODAL }))
    }

    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader toggle={handleClose}>
                <p className="m-0">{t('app.common.returnToOffer')}</p>
            </ModalHeader>
            <hr className="mx-3 mb-1" />
            <ModalBody>
                <p className="text-muted">{t('modal.returnToOffer.message')}</p>
                <Form onSubmit={formik.handleSubmit} className="py-2 d-flex flex-column">
                    {formFields.map((field) => (
                        <div key={field.name} className="form-check mb-3">
                            <Input
                                type="checkbox"
                                id={field.name}
                                name={field.name}
                                className="form-check-input"
                                checked={formik.values[field.name] === 1}
                                onChange={(e) => formik.setFieldValue(field.name, e.target.checked ? 1 : 0)}
                            />
                            <Label className="form-check-label" for={field.name}>
                                {t(field.label)}
                            </Label>
                        </div>
                    ))}
                    <Button className="btn-label align-self-end" type="submit" color="success" disabled={isPending}>
                        {isPending ? (
                            <i className="mdi mdi-spin mdi-loading label-icon align-middle fs-16 me-2"></i>
                        ) : (
                            <i className="mdi mdi-check label-icon align-middle fs-16 me-2"></i>
                        )}

                        {t('button.save')}
                    </Button>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default ReturnToOffer
